<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title>
        Neue Kategorie
      </v-card-title>
      <v-text-field
        v-model="catName"
        label="Kategoriename"
        prepend-icon="name"
      ></v-text-field>
      <v-card-text>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat @click="dialog=false">Schliessen</v-btn>
        <v-spacer>
        </v-spacer>
        <v-btn color="primary" dark @click="saveItem">Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'NewCategoryDialog',
  props: {
    categories: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
      catName: '',
      menu: false,
      date: '',
      dateObj: new Date(),
      datePS: '',
      dialog: false,
      currentItem: null,
      isLoading: false
    }
  },
  methods: {
    onUpdateDone: function (data) {
      console.log('onUpdateDone', data)
      this.dialog = false
      Vue.prototype.$eventHub.$emit('newCategoryAdded', data)
    },
    onError (error, var1, var2) {
      console.log('onError', error, var1, var2)
      this.isLoading = false
      this.hasError = true
      this.errorText = JSON.stringify(error)
    },
    saveItem: function () {
      console.log('saveItem', this.catName)
      var catObject = {
        name: this.catName
      }

      Vue.prototype.$dms.addStorageItemCategory(catObject, this.onUpdateDone)
      console.log('saveItem', this.currentItem)
    },
    open (fileItem) {
      this.currentItem = fileItem
      this.dialog = true
    }
  },
  mounted () {
    this.isLoading = true
    // Vue.prototype.scanApi.getCategories(this.onGetCategories)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/dialogs/NewCategoryDialog.vue